var map = {
	"./cnn-money-x2.png": 2028,
	"./economist-x2.png": 2029,
	"./mashable-x2.png": 2030,
	"./tech-crunch-x2.png": 2031,
	"./thenewyorker-x2.png": 2032,
	"./thrillist-x2.png": 2033,
	"./time-x2.png": 2034,
	"./usa-today-x2.png": 2035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2246;